module.exports = "https://web-assets-production.autolist.com/_next/static/images/sacramento-ca-5af99cda51342e77feeebd57bfe2225d.jpg";